<template>
  <div id="ClientsDetailsAdmin">
    <main>
      <div class="page-header pb-10 page-header-dark bg-gradient-primary-to-secondary">
        <div class="container-fluid">
          <div class="page-header-content">
            <h1 class="page-header-title">
              <div class="page-header-icon">
                <i data-feather="activity"></i>
              </div>
              <span>{{ client.shortName }}</span>
            </h1>
            <div class="page-header-subtitle">
              <span v-if="client.businessStatus === 'potential'">Potential Clients</span>
              <span v-if="client.businessStatus === 'client'">Actual Clients</span>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid mt-n10">
        <div class="row">
          <div class="col-md-12">
            <div class="card mb-4">
              <!-- <div class="card-header">DataTable Example</div> -->
              <div class="card-body">
                <div class="row">
                  <div class="col-md-8">
                    <table class="table table-bordered" cellspacing="0">
                      <tr>
                        <td>
                          Client URL
                          <small>(Demo)</small>
                        </td>
                        <td>
                          <div v-if="client.deployments.length > 0">
                            <a target="_blank" :href="clientSupportSite">{{ clientSupportSite }}</a>
                          </div>
                          <div v-if="client.deployments.length < 1">
                            <button class="btn btn-outline-danger btn-xs btn" @click="deploy()">Deploy</button>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Client ID</td>
                        <td>{{ client.ref }}</td>
                      </tr>
                      <tr>
                        <td>Full Name</td>
                        <td>{{ client.name }}</td>
                      </tr>
                      <tr>
                        <td>Short Name</td>
                        <td>{{ client.shortName }}</td>
                      </tr>
                      <tr>
                        <td>State</td>
                        <td>{{ client.state }}</td>
                      </tr>
                      <tr>
                        <td>Zone</td>
                        <td>{{ client.zone }}</td>
                      </tr>
                      <tr>
                        <td>Top-Category Label</td>
                        <td>{{ client.topCategoryLabel }}</td>
                      </tr>
                      <tr>
                        <td>Sub-Category Label</td>
                        <td>{{ client.subCategoryLabel }}</td>
                      </tr>
                      <tr>
                        <td>Agent Label</td>
                        <td>{{ client.agentLabel }}</td>
                      </tr>
                      <tr>
                        <td>Supervisor Label</td>
                        <td>{{ client.supervisorLabel }}</td>
                      </tr>
                      <tr>
                        <td>Top categories</td>
                        <td>
                          <table>
                            <tr>
                              <td>{{ client.categories.length }}</td>
                              <td><view-categories :categories="client.categories" modalID="topCatView" /></td>
                              <td><add-categories :clientRef="client.ref" /></td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td>Subategories</td>
                        <td>
                          <table>
                            <tr>
                              <td>{{ client.subCategories.length }}</td>
                              <td><view-categories :categories="client.categories" modalID="subCatView" /></td>
                              <td><add-sub-categories :clientRef="client.ref" :categories="client.categories" /></td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Engagement Level(s)
                          <br />
                          <div class="progress">
                            <div
                              class="progress-bar"
                              role="progressbar"
                              :style="'width:' + (client.salesSteps.length / totalSalesSteps) * 100 + '%;'"
                              :aria-valuenow="(client.salesSteps.length / totalSalesSteps) * 100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            >
                              {{ (client.salesSteps.length / totalSalesSteps) * 100 }}%
                            </div>
                          </div>
                        </td>
                        <td>
                          <ul style="padding-left: 10px">
                            <li v-for="(item, index) in client.salesSteps" :key="index">
                              {{ item.name }}
                              <button @click="removeSalesStepToClient(item, index)" class="btn btn-xs" style="font-size: 11px">[remove]</button>
                            </li>
                          </ul>
                          <!-- v-model="selectedSalesStep" -->
                          <select class="form-control" @change="addSalesStepToClient($event)">
                            <option value>add new level ...</option>
                            <option v-for="(item, index) in salesStepsComputed" :key="index" :value="item.name + ',' + item.uuid">{{ item.name }}</option>
                          </select>
                        </td>
                      </tr>
                    </table>
                  </div>

                  <!-- Recent Deployments -->
                  <div class="col-md-4 text-center">
                    <div class="logo">
                      <img :src="logo" :alt="client.shortName" />
                    </div>

                    <div v-if="client.deployments.length > 0">
                      <hr />
                      Recent Deployments
                      <table class="table table-sm" style="font-size: 12px">
                        <tr v-for="(item, index) in client.deployments" :key="index">
                          <td class="text-left">{{ item.createdAt | formatDateTime }}</td>
                          <td class="text-right">{{ item.user.name }}</td>
                        </tr>
                      </table>

                      <p>
                        <button class="btn btn-outline-danger btn" @click="deploy()">Update deployment</button>
                      </p>

                      <p>
                        <button class="btn btn-outline-primary btn" @click="generateSampleData()" v-if="client.businessStatus == 'potential'">Generate Sample Data</button>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>


<script>
import axios from "axios";
import comparer from "../../helper/comparer";
import AddCategories from "../../components/AddCategories.vue";
import ViewCategories from "../../components/ViewCategories.vue";
import AddSubCategories from "../../components/AddSubCategories.vue";

export default {
  name: "ClientsDetailsAdmin",

  components: {
    AddCategories,
    ViewCategories,
    AddSubCategories,
  },

  data() {
    return {
      client: {
        ref: "",
        name: "",
        shortName: "",
        topCategoryLabel: "",
        subCategoryLabel: "",
        agentLabel: "",
        supervisorLabel: "",
        categories: [],
        subCategories: [],
        salesSteps: [],
        deployments: [],
      },
      salesSteps: [],
      logo: "",
      totalSalesSteps: 0,
    };
  },

  watch: {
    "$route.params.ref": function (ref) {
      this.loadClients(ref);
      this.loadSalesSteps();
      window.scrollTo(0, 0);
    },
  },

  mounted() {
    this.loadClient(this.$route.params.ref);
    this.loadSalesSteps();
    window.scrollTo(0, 0);
  },

  methods: {
    loadClient(ref) {
      let loading = this.$loading.show();
      axios.get("/team/client/" + ref).then((res) => {
        this.client = res.data.client;
        this.logo = res.data.logo;
        this.totalSalesSteps = res.data.totalSalesSteps;
        loading.hide();
      });
    },

    deploy() {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "Please confirm you want to deploy for " + this.client.ref,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        })
        .then((result) => {
          if (result.value) {
            /* actural action */
            let loading = this.$loading.show();
            axios.get(`/team/deploy/${this.client.ref}`).then((res) => {
              if (res.data.status == "success") {
                this.loadClient(this.client.ref);
                this.$swal("", res.data.message, "success");
              } else {
                this.$swal("", res.data.message, "error");
              }
              loading.hide();
            });
            /* end of actural action */
          }
        });
    },

    loadSalesSteps() {
      axios.get("/team/sales-steps").then((res) => {
        this.salesSteps = res.data.salesSteps;
      });
    },

    addSalesStepToClient(e) {
      let value = e.target.value;
      if (value == "") {
        return;
      }
      let nameAndUUID = value.split(",");
      let salesStepName = nameAndUUID[0];
      let salesStepUUID = nameAndUUID[1];

      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You are about to add " + salesStepName,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        })
        .then((result) => {
          if (result.value) {
            /* actural action */
            let loading = this.$loading.show();

            let formData = new FormData();
            formData.append("saleStepUUID", salesStepUUID);
            formData.append("clientUUID", this.client.uuid);

            axios.post("/team/sales-steps/add-to-client", formData).then((res) => {
              if (res.data.status == "success") {
                //console.log(res.data.salesStep);
                this.client.salesSteps.push(res.data.salesStep);
                this.$swal("", res.data.message, "success");
              } else {
                this.$swal("", res.data.message, "error");
              }
              loading.hide();
            });
            /* end of actural action */
          }
        });
    },

    removeSalesStepToClient(salesStep, index) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You are about to remove " + salesStep.name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        })
        .then((result) => {
          if (result.value) {
            /* actural action */
            let loading = this.$loading.show();

            let formData = new FormData();
            formData.append("saleStepUUID", salesStep.uuid);
            formData.append("clientUUID", this.client.uuid);

            axios.post("/team/sales-steps/remove-from-client", formData).then((res) => {
              if (res.data.status == "success") {
                this.client.salesSteps.splice(index, 1);
                this.$swal("", res.data.message, "success");
              } else {
                this.$swal("", res.data.message, "error");
              }
              loading.hide();
            });
            /* end of actural action */
          }
        });
    },

    generateSampleData() {
      // /team/generate-sample-tickets/{ref:string}
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "Please confirm you want to generate sample data for " + this.client.ref,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        })
        .then((result) => {
          if (result.value) {
            /* actural action */
            let loading = this.$loading.show();
            axios.post(`/team/generate-sample-tickets/${this.client.ref}`).then((res) => {
              if (res.data.status == "success") {
                //this.loadClient(this.client.ref);
                this.$swal("", res.data.message, "success");
              } else {
                this.$swal("", res.data.message, "error");
              }
              loading.hide();
            });
            /* end of actural action */
          }
        });
    },
  },

  computed: {
    clientSupportSite() {
      let ref = this.client.ref.toLowerCase();
      return `https://${ref}.esupport.ng`;
    },

    salesStepsComputed() {
      //console.log("from computed ...........................");
      //console.log(this.salesSteps);
      //console.log(this.client.salesSteps);
      //console.log(comparer.differences(this.salesSteps, this.client.salesSteps));
      return comparer.differences(this.salesSteps, this.client.salesSteps);
    },
  },
};
</script>

<style scoped>
.logo {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo img {
  height: 6rem;
}
</style>

